<form #addCrmForm="ngForm" [class.submitted]="addCrmForm.submitted" (ngSubmit)="submit()" class="w-100 add-crm-form" novalidate>
  <div class="add-crm-body">
    <div class="form-group d-flex flex-row align-items-end" *ngIf="!isCrmProject">
      <div class="flex-grow-1">
        <label for="company" class="add-crm-label">{{ "GENERICS.COMPANY" | translate }}<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="companyRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <ng-select [(ngModel)]="item.companies[0].company"
                   [disabled]="!!(inputCompanyId || inputCrmItem)" [items]="companyList"
                   [multiple]="false"
                   [typeahead]="companyTypeahead" [loading]="companySearching" bindLabel="name"
                   (change)="handleCompanyChange($event)"
                   name="company" id="company" #companyRef="ngModel" required>
        </ng-select>
        <div *ngIf="companyError" class="error">{{ companyError }}</div>
      </div>
      <div *ngIf="!(inputCompanyId || inputCrmItem)" class="d-flex mt-3 ml-3">
        <div class="new-company-button align-content-center" (click)="addCompany()">{{ "CRM.ADD_CRM_MODAL.NEW_RMS_COMPANY"| translate }}</div>
      </div>
    </div>

    <div class="d-flex flex-row w-100">
      <div class="form-group flex-grow-1">
        <label for="crm-name" class="add-crm-label">{{ "CRM.ADD_CRM_MODAL.SONAR_RECORD_NAME" | translate }}<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="nameRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <input id="crm-name" name="crm-name" class="form-control" [(ngModel)]="item.name" #nameRef="ngModel" required />
      </div>
      <div *ngIf="!editMode && (inputCompanyId === null || inputCompanyId === undefined)" class="checkbox d-flex align-items-center">
        <input id="crm-project" name="crm-project" class="form-control checkbox" [disabled]="editMode" [(ngModel)]="isCrmProject" (change)="handleCrmTypeChange()" type="checkbox" />
        <label for="crm-project" class="crm-project-label">Project</label>
      </div>
    </div>

    <div class="form-group" *ngIf="isCrmProject">
      <label for="crm-description" class="add-crm-label">{{ "CRM.PROJECT_TOPIC" | translate }}</label>
      <textarea id="crm-description" name="crm-description" class="form-control" [(ngModel)]="item.description" #descrRef="ngModel" rows="2">
      </textarea>
    </div>

    <div class="form-group">
      <label for="status" class="add-crm-label">{{(this.isCrmProject ?  "CRM.PROJECT_STATUS" : "CRM.CRM_NOTE_SNAPSHOT.INVESTMENT_STAGE") | translate}}
        <rms-required-label [formFieldReference]="statusRef" [componentForm]="addCrmForm"></rms-required-label>
      </label>
      <ng-select [(ngModel)]="item.status" name="status" id="status" #statusRef="ngModel" required (change)="clearSilence()" [items]="availableStatuses" class="status-dropdown"
                 groupBy="group" bindValue="name" bindLabel="name">
        <ng-template ng-label-tmp let-status="item">
          <div>{{statusLabels[status.name]}}</div>
        </ng-template>
        <ng-template ng-option-tmp let-status="item" let-index="index" >
          <div>{{statusLabels[status.name]}} <i *ngIf="crmStatusService.isOptionalStatus(status)" class="optional-status">{{ "CRM.OPTIONAL" | translate }}</i></div>
        </ng-template>
      </ng-select>
    </div>

    <div class="d-flex" *ngIf="item.companies[0]?.company">
      <div class="form-group w-50 mr-3">
        <label for="courtship">{{ "CRM.COURTSHIP" | translate }}</label>
        <select [(ngModel)]="item.companies[0].company.courtshipType" id="courtship" name="courtship" class="form-control">
          <option [value]="courtship.NONE" selected>{{ "CRM.COURTSHIP_TYPES.NO_COURTSHIP" | translate }}</option>
          <option [value]="courtship.STANDARD">{{ "CRM.COURTSHIP_TYPES.STANDARD_COURTSHIP" | translate }}</option>
        </select>
      </div>

      <div class="form-group w-50 ml-3">
        <label for="storm">{{ "CRM.STORM" | translate }}<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="stormRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <select (ngModelChange)="item.companies[0].storm = $event"
                [ngModel]="item.companies[0]?.company?.isPrivate ? item.companies[0]?.storm : storm.PUBLIC"
                [disabled]="!item.companies[0]?.company?.isPrivate"
                id="storm" name="storm" class="form-control" #stormRef="ngModel">
          <option [value]="storm.EARLY_STAGE">{{ "CRM.STORM_TYPES.EARLY_STAGE" | translate }}</option>
          <option [value]="storm.CROSSOVER_IPO">{{ "CRM.STORM_TYPES.CROSSOVER" | translate }}</option>
          <option [value]="storm.PUBLIC" *ngIf="!item.companies[0]?.company?.isPrivate">{{ "CRM.STORM_TYPES.PUBLIC" | translate }}</option>
        </select>
      </div>
    </div>

    <div class="d-flex w-100">
      <div class="form-group w-50 mr-3 pr-3">
        <div *ngIf="showSilenceUntil()">
          <label for="silenceUntilDate" [ngbTooltip]="remindMeTooltip"> {{ "CRM.ADD_CRM_MODAL.SILENCE_UNTIL" | translate }}...
            <div *ngIf="crmStatusService.hasEtakiStatus(item)" class="d-inline">
              <sup class="red">*</sup>
              <rms-required-label [formFieldReference]="dp" [componentForm]="addCrmForm"></rms-required-label>
            </div>
          </label>
          <div class="input-group">
            <rms-date-picker id="silenceUntilDate"
                             name="silenceUntilDate"
                             #dp="ngModel"
                             [(ngModel)]="silenceUntilDate"
                             [min]="curDate"
                             [isRange]="false">
            </rms-date-picker>
          </div>
          <ng-template #remindMeTooltip>
            {{ "CRM.ADD_CRM_MODAL.REMIND_ME_TOOLTIP" | translate }}
          </ng-template>
          <div class="help-text">
            <i class="fa fa-info-circle"></i>
            {{ "CRM.ADD_CRM_MODAL.SILENCE_UNTIL_INFO" | translate }}
          </div>
        </div>
      </div>

      <div class="form-group w-50 ml-3" *ngIf="item.companies[0]?.company && item.status === crmStatus.RECOMMEND_AWAITING_KEY_INFLECTION">
        <label for="etaki">{{ "CRM.ADD_CRM_MODAL.ETAKI" | translate }} ({{ "CRM.ETAKI" | translate | uppercase }})
          <div *ngIf="crmStatusService.hasEtakiStatus(item)" class="d-inline">
            <sup class="red">*</sup>
            <rms-required-label [formFieldReference]="etakiRef" [componentForm]="addCrmForm"></rms-required-label>
          </div>
        </label>
        <input id="etaki" name="etaki" type="text" class="form-control" placeholder="e.g. XQXX"
               [(ngModel)]="item.companies[0].etaki" (blur)="updateSilenceUntil(etakiRef.value)"
               #etakiRef>
        <div class="help-text">
          <i class="fa fa-info-circle"></i>
          {{ "CRM.ADD_CRM_MODAL.ETAKI_INFO" | translate }}
        </div>
      </div>
    </div>

    <div class="d-flex add-crm-user-select-container">

      <div class="form-group w-50 mr-2">
        <rms-domain-selector class="add-crm-form-control" [(ngModel)]="item.domains[0]" [multiple]="false" [isRequired]="true" name="domain"></rms-domain-selector>
      </div>

      <div class="form-group w-50 mx-2">
        <rms-crm-user-select class="add-crm-form-control" [(ngModel)]="item.leader" [label]="'Sonar Lead'" [multiple]="false" [clearable]="false" name="leader"></rms-crm-user-select>
      </div>

      <div class="form-group w-50 ml-2">
        <rms-crm-user-select class="add-crm-form-control" [(ngModel)]="item.triageOwner" [label]="'Triage Owner'" [multiple]="false" [required]="false"  [clearable]="false" name="triageOwner"></rms-crm-user-select>
      </div>

    </div>


    <div class="form-group">
      <rms-crm-user-select class="add-crm-form-control" [(ngModel)]="item.participants" [label]="'Participants'" [required]="false" name="users"></rms-crm-user-select>
    </div>
    <div class="form-group">
      <div class="btn btn-link" (click)="showMore = !showMore">
        {{(showMore ? 'CRM.ADD_CRM_MODAL.HIDE_POST_DEAL_DETAILS': 'CRM.ADD_CRM_MODAL.SHOW_POST_DEAL_DETAILS') | translate}}
        <i [ngClass]="showMore ? 'fa-angle-up' : 'fa-angle-down'"  class="fa"></i>
      </div>
      <div *ngIf="showMore" class="my-2">
        <div class="d-flex w-100 m-2 px-2" *ngIf="INVESTMENT_MADE_STATUSES.includes(item.status)">
          <div class="form-group w-50 mr-3">
            <label for="crm-indicated" class="add-crm-label">{{ "CRM.ADD_CRM_MODAL.INDICATED" | translate }}</label>
            <input id="crm-indicated" name="crm-indicated" class="form-control" type="number" [(ngModel)]="item.indicated" />
          </div>

          <div class="form-group w-50 ml-3">
            <label for="crm-received" class="add-crm-label">{{ "CRM.ADD_CRM_MODAL.RECEIVED" | translate }}</label>
            <input id="crm-received" name="crm-received" class="form-control" type="number" [(ngModel)]="item.received" />
          </div>
        </div>
        <div class="m-2 px-2">
          <div class="d-flex flex-row justify-content-between">
            <div>{{'CRM.ADD_CRM_MODAL.ENFUSION_IDS' | translate}}</div>
            <div class="mx-2 btn btn-link"  (click)="item.externalIds.push({externalId: null, idType: 'ENFUSION'})">
              {{'CRM.ADD_CRM_MODAL.ADD_ENFUSION_ID' | translate}}
            </div>
          </div>
          <div *ngFor="let enfId of item.externalIds; index as i; trackBy:i">
            <div class="d-flex flex-row my-1">
              <input [id]="'crm-enfusion-id-' + i" [name]="'crm-enfusion-id-' + i" class="form-control" [value]="item.externalIds[i]?.externalId" (change)="updateEnfusionId($event, i)" />
              <button class="btn btn-delete" (click)="item.externalIds.splice(i, 1)"><i class="fa fa-trash trash-red"></i></button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <ng-content></ng-content>
</form>
